<div class="call-intent-container" [class.compact]="isCompact()">
    <div class="contact-modal">
        <div class="modal-header-section">
            <h4>Call intent</h4>
            <mat-icon [svgIcon]="'close'" class="mat-icon-24 p1-50-color pointerCursor" (click)="close()"></mat-icon>
        </div>
        <form [formGroup]="form">
            @if (!isCompact()) {
            <!-- 3-column layout -->
            <div class="sections-row">
                <div class="intent-section">
                    <h5>Policy Acquisition</h5>
                    <div class="flex-column">
                        <lib-input-checkbox [field]="coverageField" formControlName="coverage"></lib-input-checkbox>
                        <lib-input-checkbox [field]="quoteField" formControlName="quote"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="applicationSubmittalField"
                            formControlName="applicationSubmittal"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="pointOfSaleTechSupportField"
                            formControlName="pointOfSaleTechSupport"
                        ></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>Policy Serving</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="servingCoverageField"
                            formControlName="servingCoverage"
                        ></lib-input-checkbox>
                        <lib-input-checkbox [field]="renewalField" formControlName="renewal"></lib-input-checkbox>
                        <lib-input-checkbox [field]="nonRenewalField" formControlName="nonRenewal"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="conditionalRenewalField"
                            formControlName="conditionalRenewal"
                        ></lib-input-checkbox>

                        <!-- ADD HERE -->
                    </div>
                </div>
                <div class="intent-section">
                    <h5 style="visibility: hidden">Policy Serving</h5>
                    <div class="flex-column">
                        <lib-input-checkbox [field]="noticesField" formControlName="notices"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="endorsementRequestField"
                            formControlName="endorsement"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="submittalsAcknowledgementField"
                            formControlName="Submittals Acknowledgement"
                        ></lib-input-checkbox>
                        <!-- ADD HERE -->
                    </div>
                </div>
            </div>
            <div class="separator"></div>
            <div class="sections-row">
                <div class="intent-section">
                    <h5>Billing</h5>
                    <div class="flex-column">
                        <lib-input-checkbox [field]="paymentsField" formControlName="Payments"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="billPayField"
                            formControlName="Bill pay (Guest pay)"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="paymentPlanField"
                            formControlName="Payment plan"
                        ></lib-input-checkbox>
                        <lib-input-checkbox [field]="invoicesField" formControlName="Invoices"></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>Payment method</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="paperInvoiceField"
                            formControlName="Paper Invoice"
                        ></lib-input-checkbox>
                        <lib-input-checkbox [field]="ccField" formControlName="CC"></lib-input-checkbox>
                        <lib-input-checkbox [field]="eftField" formControlName="EFT"></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>Cancellation</h5>
                    <div class="flex-column">
                        <lib-input-checkbox [field]="pcnField" formControlName="PCN"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="cancellationRequestsField"
                            formControlName="Cancellation Requests"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="refundCheckField"
                            formControlName="Refund Check"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="unclaimedPropertyChecksField"
                            formControlName="Unclaimed Property Checks"
                        ></lib-input-checkbox>
                    </div>
                </div>
            </div>
            <div class="separator"></div>
            <div class="sections-row">
                <div class="intent-section">
                    <h5>Mortgage</h5>
                    <div class="flex-column">
                        <lib-input-checkbox [field]="cvgPoiField" formControlName="CVG and/or POI"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="mortgageEscrowUpdatesField"
                            formControlName="Mortgage and/or Escrow Updates"
                        ></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>Moratoriums</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="bindingSuspensionField"
                            formControlName="Binding Suspension"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="catRelatedField"
                            formControlName="CAT Related"
                        ></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>System Related</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="producerAccessSupportField"
                            formControlName="Producer Access Support"
                        ></lib-input-checkbox>
                        <lib-input-checkbox [field]="jiraTicketField" formControlName="JIRA"></lib-input-checkbox>
                    </div>
                </div>
            </div>
            <div class="separator"></div>
            <div class="sections-row">
                <div class="intent-section">
                    <h5>Claims</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="claimsReportField"
                            formControlName="Claims Report"
                        ></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>Commission Statement</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="commissionCheckField"
                            formControlName="Commission Check"
                        ></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>State of Emergency</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="stateOfEmergencyField"
                            formControlName="State of Emergency"
                        ></lib-input-checkbox>
                    </div>
                </div>
            </div>
            } @else {
            <!-- Compact 2-column layout with proper grouping -->
            <div class="sections-row">
                <div class="intent-section">
                    <h5>Policy Acquisition</h5>
                    <div class="flex-column">
                        <lib-input-checkbox [field]="coverageField" formControlName="coverage"></lib-input-checkbox>
                        <lib-input-checkbox [field]="quoteField" formControlName="quote"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="applicationSubmittalField"
                            formControlName="Application Submittal"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="pointOfSaleTechSupportField"
                            formControlName="pointOfSaleTechSupport"
                        ></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>Policy Serving</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="servingCoverageField"
                            formControlName="servingCoverage"
                        ></lib-input-checkbox>
                        <lib-input-checkbox [field]="renewalField" formControlName="renewal"></lib-input-checkbox>
                        <lib-input-checkbox [field]="nonRenewalField" formControlName="nonRenewal"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="conditionalRenewalField"
                            formControlName="conditionalRenewal"
                        ></lib-input-checkbox>
                        <lib-input-checkbox [field]="noticesField" formControlName="notices"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="endorsementRequestField"
                            formControlName="endorsement"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="submittalsAcknowledgementField"
                            formControlName="Submittals Acknowledgement"
                        ></lib-input-checkbox>
                        <!-- ADD HERE -->
                    </div>
                </div>
            </div>
            <div class="separator"></div>
            <div class="sections-row">
                <div class="intent-section">
                    <h5>Billing</h5>
                    <div class="flex-column">
                        <lib-input-checkbox [field]="paymentsField" formControlName="Payments"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="billPayField"
                            formControlName="Bill pay (Guest pay)"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="paymentPlanField"
                            formControlName="Payment plan"
                        ></lib-input-checkbox>
                        <lib-input-checkbox [field]="invoicesField" formControlName="Invoices"></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>Payment method</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="paperInvoiceField"
                            formControlName="Paper Invoice"
                        ></lib-input-checkbox>
                        <lib-input-checkbox [field]="ccField" formControlName="CC"></lib-input-checkbox>
                        <lib-input-checkbox [field]="eftField" formControlName="EFT"></lib-input-checkbox>
                    </div>
                </div>
            </div>
            <div class="separator"></div>
            <div class="sections-row">
                <div class="intent-section">
                    <h5>Cancellation</h5>
                    <div class="flex-column">
                        <lib-input-checkbox [field]="pcnField" formControlName="PCN"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="cancellationRequestsField"
                            formControlName="Cancellation Requests"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="refundCheckField"
                            formControlName="Refund Check"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="unclaimedPropertyChecksField"
                            formControlName="Unclaimed Property Checks"
                        ></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>Mortgage</h5>
                    <div class="flex-column">
                        <lib-input-checkbox [field]="cvgPoiField" formControlName="CVG and/or POI"></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="mortgageEscrowUpdatesField"
                            formControlName="Mortgage and/or Escrow Updates"
                        ></lib-input-checkbox>
                    </div>
                </div>
            </div>
            <div class="separator"></div>
            <div class="sections-row">
                <div class="intent-section">
                    <h5>Moratoriums</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="bindingSuspensionField"
                            formControlName="Binding Suspension"
                        ></lib-input-checkbox>
                        <lib-input-checkbox
                            [field]="catRelatedField"
                            formControlName="CAT Related"
                        ></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>System Related</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="producerAccessSupportField"
                            formControlName="Producer Access Support"
                        ></lib-input-checkbox>
                        <lib-input-checkbox [field]="jiraTicketField" formControlName="JIRA"></lib-input-checkbox>
                    </div>
                </div>
            </div>
            <div class="separator"></div>
            <div class="sections-row">
                <div class="intent-section">
                    <h5>Claims</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="claimsReportField"
                            formControlName="Claims Report"
                        ></lib-input-checkbox>
                    </div>
                </div>
                <div class="intent-section">
                    <h5>Commission Statement</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="commissionCheckField"
                            formControlName="Commission Check"
                        ></lib-input-checkbox>
                    </div>
                </div>
            </div>
            <div class="separator"></div>
            <div class="sections-row">
                <div class="intent-section">
                    <h5>State of Emergency</h5>
                    <div class="flex-column">
                        <lib-input-checkbox
                            [field]="stateOfEmergencyField"
                            formControlName="State of Emergency"
                        ></lib-input-checkbox>
                    </div>
                </div>
            </div>
            }
        </form>

        <div class="modal-action-row">
            <lib-button
                buttonText="Confirm"
                buttonTheme="primary"
                buttonSize="medium"
                (click)="confirmSelection()"
            ></lib-button>
        </div>
    </div>
</div>
@if (showNoSelectionModal()) {
<div class="no-selection-backdrop" (click)="showNoSelectionModal.set(false)"></div>
<div class="no-selection-modal">
    <mat-icon
        [svgIcon]="'exclamation-circle'"
        class="s2-90-color mat-icon-64"
        style="width: 64px; height: 64px; font-size: 64px; overflow: visible; color: orange"
    ></mat-icon>
    <h5 class="" style="text-align: center">No call intent is selected</h5>
    <p class="caption" style="text-align: center">To continue, choose at least one option from the list.</p>
    <lib-button
        buttonText="OK, got it"
        buttonTheme="primary"
        buttonSize="medium"
        (callback)="showNoSelectionModal.set(false)"
    ></lib-button>
</div>
}
